const messages = {
    email: 'email-validation-error',
    phone: 'phone-validation-error',
    password: {
        lengthReq: 'password-length-restriction',
        caseReq: 'password-case-restriction',
        specialCharReq: 'password-char-restriction',
        numberReq: 'password-number-restriction',
        emailReq: 'password-email-restriction',
    },
    zipcode: 'zipcode-validation-error',
    required: 'required',
    login: 'login', // same as required
};

function emailValidate(value) {
    const message = messages.email;
    let isValid = false;
    if (!value || value.length < 3) {
        return { isValid, message };
    }

    isValid = value.includes('@');
    return { isValid, message };
}

function phoneValidate(value) {
    const message = messages.phone;
    let isValid = false;
    if (!value) {
        return { isValid, message };
    }

    const digitsOnly = value.replace(/\D+/g, '');
    const firstSevenCharactersAreValid = /^[0-9.+\-()\s]{7,}$/g.test(value);

    isValid = firstSevenCharactersAreValid && digitsOnly.length <= 15;
    return { isValid, message };
}

function passwordValidate(value, userEmail) {
    const messageObj = {};

    const lengthReq = !!value && value.length >= 6 && value.length <= 64;

    if (!lengthReq) {
        messageObj['invalid-lengthReq'] = true;
    }

    // check to see if password contains at least one upper case and lower case character
    const caseReq = new RegExp('^(?=.*[a-z])(?=.*[A-Z]).+$');

    if (!caseReq.test(value)) {
        messageObj['invalid-caseReq'] = true;
    }

    // check to see if password contains at least one number
    const numberReq = new RegExp('^(?=.*\\d).+$');

    if (!numberReq.test(value)) {
        messageObj['invalid-numberReq'] = true;
    }

    // check to see if password contains at least one special character
    const specialCharReq = new RegExp('^(?=.*[-+_!@#$%^&*.,?]).+$');

    if (!specialCharReq.test(value)) {
        messageObj['invalid-specialCharReq'] = true;
    }

    const emailReq = value !== userEmail;

    if (!emailReq) {
        messageObj['invalid-emailReq'] = true;
    }

    const isValid = lengthReq
        && caseReq.test(value)
        && numberReq.test(value)
        && specialCharReq.test(value)
        && emailReq;

    return { isValid, message: messageObj };
}

function zipcodeValidate(value) {
    const message = messages.zipcode;
    const isValid = !!value && value.length <= 25;

    return { isValid, message };
}

function optionalValidate(fn) {
    return (value) => {
        if (!value || value.length === 0) {
            return { isValid: true, message: undefined };
        }
        return fn(value);
    };
}

function requiredValidate(fn) {
    const message = messages.required;
    return (value, maxLength = 255, userEmail) => {
        if (!value || value.length === 0 || value.length > maxLength) {
            return { isValid: false, message };
        }
        return fn(value, userEmail);
    };
}

const validations = {
    email: emailValidate,
    phone: phoneValidate,
    password: passwordValidate,
    zipcode: zipcodeValidate,
    optional: optionalValidate,
    required: requiredValidate,
};

export {
    messages,
    validations,
};
